import Icon from 'components/Icon/Icon';
import './PouringAnimation.scss';

const PouringAnimation = () => {
  return (
    <div className="pouring-animation">
      <Icon icon="beer-pouring-1" />
      <Icon icon="beer-pouring-2" />
      <Icon icon="beer-pouring-3" />
      <Icon icon="beer-pouring-4" />
      <Icon icon="beer-pouring-5" />
      <Icon icon="beer-pouring-6" />
    </div>
  );
};

export default PouringAnimation;
